import React from 'react';
import classes from './customCalendarHeader.module.scss';

function CustomCalendarHeader(props) {
  const { date, changeYear, changeMonth, withMonth = true } = props;

  const years = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 1970; i <= new Date().getFullYear() + 10; i++) {
    years.push(`${i}`);
  }

  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  return (
    <div
      style={{
        margin: 10,
        display: 'flex',
        justifyContent: 'space-around'
      }}
    >
      <select
        className={classes.selectCss}
        value={date.getFullYear()}
        onChange={({ target: { value } }) => changeYear(value)}
      >
        {years.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>

      {withMonth && (
        <select
          className={classes.selectCss}
          value={months[date.getMonth()]}
          onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}
        >
          {months.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}

export default CustomCalendarHeader;
